module.exports = __webpack_public_path__ + "static/media/error.2366444d.svg";